import { useState, useEffect } from 'react';

export default function ServiceDashboardItemSyncUsers({ data }) {
    const [syncStatus, setSyncStatus] = useState('...');

    useEffect(() => {
        if (syncStatus === '...') {
            setSyncStatus(data?.userSync ? 'Enabled' : 'Disabled');
        } else if (syncStatus !== data?.userSync) {
            setSyncStatus(data?.userSync ? 'Enabled' : 'Disabled');
        }
    }, [data?.userSync, syncStatus]);

    return syncStatus;
}
